import React from 'react';
import { MessageCircle, Clock } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const WhatsAppConfirmModal = ({ order, onClose }) => {
  const { settings } = useSettings();
  if (!order) return null;

  const buildMessage = () => {
    const itemsList = (order.items || [])
      .map(i => `• ${i.productName}${i.size ? ` (${i.size})` : ''} x ${i.quantity} = ₹${i.price * i.quantity}`)
      .join('\n');
    const addressLine = order.orderType === 'pickup'
      ? `Pickup at: ${settings.address || 'our bakery'}`
      : `Delivery Address: ${order.deliveryAddress || 'Shared location pin'}`;

    return [
      `*Order ${order.orderNumber}*`,
      '',
      'Items:', itemsList, '',
      `Subtotal: ₹${order.subtotal}`,
      order.discount ? `Discount: -₹${order.discount}` : null,
      order.orderType === 'delivery' ? `Delivery Charge: ₹${order.deliveryCharge || 0}` : null,
      `Total: ₹${order.total}`,
      '',
      addressLine,
      '',
      `Customer: ${order.customerName} (${order.phone})`,
    ].filter(Boolean).join('\n');
  };

  const waLink = `https://wa.me/${(settings.whatsappNumber || '').replace(/\D/g, '')}?text=${encodeURIComponent(buildMessage())}`;

  return (
    <div className="fixed inset-0 bg-black/60 z-[95] flex items-center justify-center p-4" data-testid="whatsapp-confirm-modal">
      <div className="bg-white rounded-2xl w-full max-w-sm shadow-2xl p-6 text-center">
        <div className="w-14 h-14 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center mx-auto mb-4">
          <Clock size={26} className="text-amber-600" />
        </div>
        <h3 className="font-playfair text-xl font-bold text-[#1F1410] mb-2">Order Received — Not Confirmed Yet</h3>
        <p className="text-[#7A6A63] text-sm mb-5">
          Your order isn't confirmed yet. Please click the button below to confirm and pay via WhatsApp.
        </p>
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          onClick={onClose}
          className="w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-full transition-colors mb-3"
          data-testid="pay-via-whatsapp-button"
        >
          <MessageCircle size={18} /> Pay via WhatsApp
        </a>
        <button
          onClick={onClose}
          className="w-full text-[#7A6A63] text-sm hover:text-[#7A1125] transition-colors"
          data-testid="whatsapp-confirm-close"
        >
          I'll do this later
        </button>
      </div>
    </div>
  );
};

export default WhatsAppConfirmModal;
